import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_UNUSED_AUTH_REQUEST: '',
  GET_UNUSED_AUTH_SUCCESS: '',
  GET_UNUSED_AUTH_FAILURE: '',

};

types = setStoreTypeValues(types, 'authUnused');

export default types;
